import formatNumber from '@/utils/NumberFormatter';
import Validatable from '@/validator/Validatable';

import RevenueSplitCategory from './RevenueSplitCategory';
import RevenueSplitCategoryGroup from './RevenueSplitCategoryGroup';

export default class RevenueSplit extends Validatable {
  categories: RevenueSplitCategory[];

  constructor(categories = []) {
    super();
    this.categories = categories;
  }

  get revenue() {
    return this.categories.reduce((mem, x) => mem + x.revenue, 0);
  }

  get revenuePercent() {
    return this.categories.reduce((mem, x) => mem + x.revenuePercent, 0);
  }

  get revenueFormatted() {
    return `${Math.round(this.revenue)}`.length % 3 === 0
      ? formatNumber(this.revenue, '$0a')
      : formatNumber(this.revenue, '$0.0a');
  }

  get groups() {
    return [
      new RevenueSplitCategoryGroup('direct', [this.adServer, this.storefront]),
      new RevenueSplitCategoryGroup('programmatic', [this.privateDeals, this.openExchange]),
    ];
  }

  get adServer() {
    return this.categories.find((x) => x.name === 'ad_server');
  }

  get storefront() {
    return this.categories.find((x) => x.name === 'storefront');
  }

  get privateDeals() {
    return this.categories.find((x) => x.name === 'private_deals');
  }

  get openExchange() {
    return this.categories.find((x) => x.name === 'open_exchange');
  }

  static fromApi(apiObject) {
    return new RevenueSplit(
      Object.keys(apiObject).map((key) => RevenueSplitCategory.fromApi({ name: key, ...apiObject[key] })),
    );
  }
}
